import { ProductType } from "../../../../../../Wrap/Constants/Enums/Domain/ProductType";
import { Money } from "../../../../../../Wrap/Core/DataTypes/Money";
import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../../react-core/Flux/BaseStore";
import { PPToProductInstructionDispatcher } from "./Variable";

export interface InstructionStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: any;
    hasCashIsa?: boolean;
}

export interface AssetsToSellFromPP {
    ProductId: number;
    ProductCode?: string;
    AssetName: string;
    ProductType: ProductType;
    MarketValue?: Money;
    DisinvestAll: boolean;
    FactsheetUrl?: string;
    IsDeferred?: boolean;
    Weighting?:number;
}

export class PPToProductInstructionStatic extends BaseStore<InstructionStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(PPToProductInstructionDispatcher, (actionData) =>
            this.onPPToProductInstructionStoreResponse(actionData)
        );
    }

    public getLastResult(): InstructionStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading === undefined ? true : this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }
    public getHasCashIsa() {
        return this.getState().hasCashIsa;
    }
    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): InstructionStaticState {
        return { actionType: ActionType.Loading, data: null, hasCashIsa: false };
    }

    private onPPToProductInstructionStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ isLoading: false, actionType: actionData.actionType, data: actionData.payload });
                break;
            case ActionType.Update:
                this.setState({ actionType: actionData.actionType, hasCashIsa: actionData.payload });
                break;
            case ActionType.Error:
                this.setState({ actionType: actionData.actionType });
                break;
            case ActionType.Loading:
                this.setState({ actionType: actionData.actionType });
                break;
        }
    }
}
